import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { AngelikaSturnFooter } from '../components/AngelikaSturnFooter';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronsDownIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function AngelikaSturnFamilientherapiePage() {
  const location = useLocation();
  const [openAccordion, setOpenAccordion] = useState<string | undefined>(undefined);
  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace('#', '');
      if (hash === 'genogrammarbeit') {
        setOpenAccordion('item-2');
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        }, 100);
      }
    }
  }, [location]);
  return <div className="min-h-screen bg-white" data-id="element-368">
      <Header data-id="element-369" />
      <main className="w-full pt-[152px]" data-id="element-370">
        <div className="w-full flex justify-center" data-id="element-371">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-372">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5ypi8wtAfwH7n8SQnfShZt/Header-Familientherapie-Angelika_Sturny.jpg" alt="Familientherapie Header Bild" className="w-full h-full object-cover" data-id="element-373" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-374"></div>
            <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-375">
              <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-376">
                <div className="max-w-lg text-left" data-id="element-377">
                  <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-378">
                    "Die Familie ist der erste Ort, an dem wir lernen, wer wir
                    sind – und wie wir mit anderen leben"
                  </blockquote>
                  <p className="text-white text-xl" data-id="element-379">– Jesper Juul</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-380">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-4" data-id="element-381">
            Systemische Familientherapie
          </h1>
          <h2 className="text-xl md:text-2xl font-light text-gray-600 mb-8" data-id="element-382">
            Beziehungen verstehen und gemeinsam wachsen
          </h2>
          <div className="text-lg text-gray-600 leading-relaxed space-y-6 mb-12" data-id="element-383">
            <p data-id="element-384">
              Familien sind lebendige Beziehungssysteme, in denen jeder oder
              jede Einzelne eine wichtige Rolle spielt. Wenn das Miteinander aus
              dem Gleichgewicht gerät, Konflikte eskalieren oder Kinder Symptome
              entwickeln, kann das für alle Beteiligten belastend sein.
              Besonders bei Schulproblemen – etwa Leistungsdruck,
              Verhaltensauffälligkeiten, Rückzug oder Überforderung – lohnt sich
              ein systemischer Blick.
            </p>
            <p data-id="element-385">
              Denn oft spiegeln sich in schulischen Schwierigkeiten auch
              familiäre Spannungen, unausgesprochene Erwartungen oder belastende
              Dynamiken wider. Die Familientherapie bietet einen Raum, in dem
              Kinder, Jugendliche und Eltern gemeinsam gehört werden und neue
              Wege der Verständigung entstehen können.
            </p>
          </div>
          <div className="mb-12 bg-blue-50 p-8 rounded-lg" data-id="element-386">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-387">
              Wann Familientherapie hilfreich sein kann:
            </h3>
            <ul className="space-y-3 text-lg text-gray-700" data-id="element-388">
              <li className="flex items-start" data-id="element-389">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-390"></div>
                <span data-id="element-391">
                  Wenn Kommunikation innerhalb der Familie schwierig ist oder
                  Missverständnisse zunehmen
                </span>
              </li>
              <li className="flex items-start" data-id="element-392">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-393"></div>
                <span data-id="element-394">
                  Wenn Konflikte zwischen Generationen oder Rollenverteilungen
                  auftreten, die Spannungen erzeugen
                </span>
              </li>
              <li className="flex items-start" data-id="element-395">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-396"></div>
                <span data-id="element-397">
                  Wenn Kinder oder Jugendliche auffälliges Verhalten zeigen oder
                  sich zurückziehen
                </span>
              </li>
              <li className="flex items-start" data-id="element-398">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-399"></div>
                <span data-id="element-400">Bei Geschwisterrivalität oder Rollenverteilung</span>
              </li>
              <li className="flex items-start" data-id="element-401">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-402"></div>
                <span data-id="element-403">
                  Bei Trennung, Verlust oder anderen belastenden
                  Lebensereignissen
                </span>
              </li>
              <li className="flex items-start" data-id="element-404">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-405"></div>
                <span data-id="element-406">
                  Bei Übergängen im Familiensystem (z. B. Pubertät, Auszug,
                  Patchwork-Konstellationen)
                </span>
              </li>
            </ul>
          </div>
          <div className="mb-12" data-id="element-407">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-408">
              Was passiert in der Familientherapie:
            </h3>
            <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-409">
              <p data-id="element-410">
                In einem geschützten Rahmen sprechen wir über das, was belastet
                – und über das, was verbindet. Wir arbeiten mit Methoden wie
                Genogrammen, systemischen Fragetechniken, Aufstellungen oder
                Kommunikationsanalysen, um Muster sichtbar zu machen und neue
                Perspektiven zu eröffnen. Kinder und Jugendliche werden
                altersgerecht einbezogen, ihre Sichtweisen ernst genommen und
                ihre Ressourcen gestärkt. Eltern erhalten Unterstützung, ihre
                Rolle bewusst zu gestalten und neue Handlungsmöglichkeiten zu
                entwickeln.
              </p>
            </div>
          </div>
          <div className="mb-12 bg-blue-50 p-8 rounded-lg" data-id="element-411">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-412">
              Ziele der Familientherapie:
            </h3>
            <ul className="space-y-3 text-lg text-gray-700" data-id="element-413">
              <li className="flex items-start" data-id="element-414">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-415"></div>
                <span data-id="element-416">
                  Verstehen, wie familiäre Beziehungsmuster wirken und sich
                  gegenseitig beeinflussen
                </span>
              </li>
              <li className="flex items-start" data-id="element-417">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-418"></div>
                <span data-id="element-419">
                  Stärken, was trägt: Vertrauen, Kommunikation, gegenseitige
                  Wertschätzung
                </span>
              </li>
              <li className="flex items-start" data-id="element-420">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-421"></div>
                <span data-id="element-422">
                  Verändern, was belastet: Konfliktdynamiken, Missverständnisse,
                  Überforderungen
                </span>
              </li>
              <li className="flex items-start" data-id="element-423">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-gray-600 mr-3 mt-2" data-id="element-424"></div>
                <span data-id="element-425">
                  Gemeinsam wachsen – als Familie, in der alle gehört und
                  gesehen werden
                </span>
              </li>
            </ul>
          </div>
          <div className="text-lg text-gray-600 leading-relaxed space-y-6 mb-12" data-id="element-426">
            <p data-id="element-427">
              Familientherapie ist eine Einladung, gemeinsam neue Wege zu gehen
              – mit Offenheit, Respekt und dem Wunsch, ein unterstützendes
              Miteinander zu gestalten. Ziel ist es, die Beziehungen zu stärken,
              gegenseitiges Verständnis zu fördern und neue
              Handlungsmöglichkeiten zu eröffnen.
            </p>
          </div>
          <div className="mb-12" data-id="element-428">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-429">
              Mein Ansatz:
            </h3>
            <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-430">
              <p data-id="element-431">
                Ich arbeite nach den Grundprinzipien der systemischen
                Familientherapie: Jede Familie ist ein einzigartiges System, in
                dem sich Bedürfnisse, Erwartungen und Rollen gegenseitig
                beeinflussen. Veränderung entsteht, wenn wir diese Dynamiken
                verstehen und gemeinsam neue Lösungen erproben. Dabei geht es
                nicht um Schuldzuweisungen, sondern um Verstehen, Verbindung und
                Entwicklung.
              </p>
            </div>
          </div>
          <div className="mb-12" data-id="element-432">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-433">
              Ablauf:
            </h3>
            <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-434">
              <p data-id="element-435">
                Im Mittelpunkt steht zunächst die Auftragsklärung. Gemeinsam mit
                der Familie kläre ich das Ziel der Therapie, um allen
                Beteiligten Orientierung und Transparenz zu geben. Ich lade alle
                Beteiligten ein, ihre Sichtweisen zu teilen. Mit systemischen
                Methoden, kreativen Impulsen und viel Raum für ehrlichen
                Austausch unterstütze ich Familien dabei, ihre Ressourcen zu
                entdecken und gemeinsam neue Wege zu gehen.
              </p>
              <p data-id="element-436">
                Ziel ist es, Klarheit zu schaffen, emotionale Entlastung zu
                ermöglichen und neue Handlungsspielräume zu eröffnen. In
                Abstimmung mit der Familie können folgende Methoden zur Klärung
                angewendet werden:
              </p>
            </div>
          </div>
          <div className="mb-12" data-id="element-437">
            <h3 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-438">
              Methoden
            </h3>
            <Accordion.Root type="single" collapsible className="space-y-4" value={openAccordion} onValueChange={setOpenAccordion} data-id="element-439">
              <AccordionItem value="item-1" title="Zirkuläres Fragen" data-id="element-440">
                <p className="text-gray-600 leading-relaxed" data-id="element-441">
                  Eine zentrale Methode der systemischen Therapie ist das
                  zirkuläre Fragen. Dabei werden die unterschiedlichen
                  Perspektiven der Familienmitglieder sichtbar gemacht. Es macht
                  deutlich, wie Familienmitglieder einander wahrnehmen. Dadurch
                  lassen sich Muster erkennen, neue Einsichten gewinnen und
                  Beziehungen besser verstehen.
                </p>
              </AccordionItem>
              <AccordionItem value="item-2" title="Genogrammarbeit" id="genogrammarbeit" data-id="element-442">
                <p className="text-gray-600 leading-relaxed" data-id="element-443">
                  Das Genogramm ist eine grafische Darstellung der
                  Familienstruktur über mehrere Generationen hinweg – eine Art
                  erweiterter Stammbaum, der Beziehungen, Rollen und Muster über
                  mehrere Generationen hinweg sichtbar macht und so hilft
                  familiäre Dynamiken besser zu verstehen. Mit dieser Methode
                  können Loyalitäten, Bindungen, Brüche und Verstrickungen
                  sichtbar gemacht und erkannt werden. Auch können biographische
                  Lebensereignisse wie Trennung, Krankheiten oder Migration in
                  den Kontext der Familiengeschichte gestellt werden. Dieser
                  ressourcenorientierte Ansatz stärkt familiäre Muster und
                  unterstützt die Klärung von Konflikten, indem neue
                  Handlungsmöglichkeiten entwickelt werden.
                </p>
              </AccordionItem>
              <AccordionItem value="item-3" title="Reframing" data-id="element-444">
                <p className="text-gray-600 leading-relaxed" data-id="element-445">
                  Reframing in der systemischen Therapie bedeutet, einer
                  Situation, einem Verhalten oder einem Problem einen neuen
                  Bedeutungsrahmen zu geben. Oft sind wir in festgefahrenen
                  Sichtweisen verstrickt – Reframing hilft, diese Perspektive zu
                  verändern und neue Handlungsmöglichkeiten zu eröffnen. Hierbei
                  wird das Verhalten in einen anderen Kontext gestellt und
                  problematische Verhaltensweisen in einer Familie werden in
                  einem neuen, konstruktiven Licht gesehen. Dadurch entstehen
                  neue Bedeutungen, die entlastend wirken, festgefahrene
                  Bewertungen auflösen und die persönliche Entwicklung fördern.
                </p>
              </AccordionItem>
              <AccordionItem value="item-4" title="Ressourcenorientierte Interventionen" data-id="element-446">
                <p className="text-gray-600 leading-relaxed" data-id="element-447">
                  Jeder Mensch verfügt über Ressourcen wie persönliche
                  Eigenschaften, soziale Netzwerke, Erfahrungen und Werte, die
                  in schwierigen Situationen aktiviert werden können.
                  Ressourcenorientierte Interventionen richten den Blick auf
                  Stärken, Fähigkeiten und Potenziale, statt ausschließlich auf
                  Probleme oder Defizite. Sie helfen dabei, eigene Kompetenzen
                  wahrzunehmen und zu nutzen, um Herausforderungen zu
                  bewältigen. Dies stärkt das Selbstvertrauen und die
                  Selbstwirksamkeit und aktiviert individuelle sowie familiäre
                  Ressourcen, die zur Lösungsfindung beitragen.
                </p>
              </AccordionItem>
              <AccordionItem value="item-5" title="Skulpturarbeit" data-id="element-448">
                <p className="text-gray-600 leading-relaxed" data-id="element-449">
                  Die Familienaufstellung ist eine kraftvolle Methode der
                  systemischen Therapie. Sie macht verborgene Beziehungsmuster,
                  emotionale Verstrickungen und generationsübergreifende
                  Dynamiken innerhalb eines Familiensystems sichtbar und
                  erlebbar. Beziehungsdynamiken und Rollen werden dabei nicht
                  nur sprachlich, sondern durch räumliche Anordnung dargestellt.
                  Körperhaltung, Abstand und Blickrichtung spiegeln emotionale
                  Nähe, Distanz oder Spannung wider. So können Beziehungsmuster
                  und Bindungen verdeutlicht und Veränderungsimpulse entwickelt
                  werden. Das Ziel ist, das gegenseitige Verständnis zu erhöhen
                  und neue Perspektiven auf die familiären Dynamiken zu
                  eröffnen.
                </p>
              </AccordionItem>
            </Accordion.Root>
          </div>
          <div className="mt-8 text-center" data-id="element-450">
            <p className="text-gray-600 mb-4" data-id="element-451">
              Die Rahmenbedingungen wie Terminvereinbarung, Ablauf und Kosten
              finden Sie unter{' '}
              <Link to="/angelika_sturny/info" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-452">
                Info
              </Link>
              .
            </p>
            <p className="text-gray-600" data-id="element-453">
              Appointments are also possible in English. Please contact me via{' '}
              <a href="mailto:praxis@angelikasturny.com" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-454">
                email
              </a>{' '}
              for sessions in English!
            </p>
          </div>
        </div>
      </main>
      <AngelikaSturnFooter data-id="element-455" />
    </div>;
}
const AccordionItem = ({
  children,
  value,
  title,
  id
}: {
  children?: React.ReactNode;
  value: string;
  title: string;
  id?: string;
}) => {
  return <Accordion.Item value={value} className="border-b border-gray-200 overflow-hidden" id={id} data-id="element-456">
      <Accordion.Header data-id="element-457">
        <Accordion.Trigger className="flex justify-between items-center w-full p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-458">
          <span className="text-lg font-medium text-gray-700" data-id="element-459">{title}</span>
          <ChevronsDownIcon className="h-5 w-5 text-[#cda8be] transition-transform duration-300 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180" data-id="element-460" />
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content className="overflow-hidden data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp" data-id="element-461">
        <div className="p-4 bg-white" data-id="element-462">{children}</div>
      </Accordion.Content>
    </Accordion.Item>;
};